module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('transition', {
    attrs: {
      "name": "router-fade",
      "mode": "out-in"
    }
  }, [(_vm.$route.meta.keepAlive) ? _c('keep-alive', [_c('router-view', {
    key: _vm.$route.name + (_vm.$route.params.id || null),
    staticClass: "animated bounceInRight"
  })], 1) : _c('router-view', {
    key: _vm.$route.name + (_vm.$route.params.id || null),
    staticClass: "animated bounceInLeft"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5812d191"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Layout/components/MainContainer/index.vue
// module id = 1221
// module chunks = 1